import { required, email, sameAs } from 'vuelidate/lib/validators'

const formData = {
  'secretaryUser.name': {
    size: 6,
    offset: 6,
    type: 'text',
    name: 'name',
    label: 'Nome completo',
    placeholder: 'Digite seu nome completo',
    value: null
  },
  // 'secretaryUser.gender': {
  //   size: 2,
  //   type: 'select',
  //   name: 'gender',
  //   label: 'Sexo',
  //   placeholder: 'Selecione',
  //   value: null,
  //   options: [
  //     {
  //       id: 'F',
  //       name: 'Feminino'
  //     },
  //     {
  //       id: 'M',
  //       name: 'Masculino'
  //     }
  //   ]
  // },
  'secretaryUser.email.first': {
    size: 6,
    type: 'text',
    name: 'secretaryUser.email.first',
    label: 'E-mail do usuário',
    placeholder: 'Digite o e-mail do usuário',
    value: null
  },
  'secretaryUser.email.second': {
    size: 6,
    type: 'text',
    name: 'secretaryUser.email.second',
    label: 'Confirmar e-mail do usuário',
    placeholder: 'e-mail@email.com.br',
    value: null,
    errors: {
      sameEmail: 'E-mail não confere'
    }
  },
  // 'cpf': {
  //   size: 6,
  //   type: 'text',
  //   name: 'cpf',
  //   label: 'CPF',
  //   placeholder: 'Digite seu CPF',
  //   mask: '###.###.###-##',
  //   value: null
  // },
  // 'rg': {
  //   size: 6,
  //   type: 'text',
  //   name: 'rg',
  //   label: 'RG',
  //   maxlength: 15,
  //   placeholder: 'Digite seu RG',
  //   value: null
  // },
  // 'contactPhone': {
  //   size: 6,
  //   type: 'text',
  //   name: 'contactPhone',
  //   label: 'Telefone',
  //   mask: '(##) #####-####',
  //   placeholder: 'Digite seu telefone',
  //   value: null
  // },
  // 'role': {
  //   size: 6,
  //   type: 'select',
  //   name: 'role',
  //   label: 'Função',
  //   required: true,
  //   value: 'ROLE_SECRETARY',
  //   options: [
  //     {
  //       id: 'ROLE_SECRETARY',
  //       name: 'Recepcionista'
  //     }
  //   ]
  // },
  'secretaryDoctorOffices': {
    size: 6,
    offset: 6,
    type: 'selectMultiple',
    name: 'secretaryDoctorOffices',
    label: 'Consultórios',
    placeholder: 'Selecione um ou mais consultórios',
    collapsed: false,
    required: true,
    value: [],
    options: []
  },
  'roles': {
    size: 12,
    hide: true,
    type: 'checkbox',
    name: 'roles',
    label: 'Permissões de acesso',
    placeholder: 'Selecione um tipo de permissão de acesso',
    required: false,
    value: null,
    checkboxes: [
      {
        name: 'access_panel',
        value: 'ROLE_ACCESS_PANEL',
        label: 'Painel de Controle'
      },
      {
        name: 'access_agenda',
        value: 'ROLE_ACCESS_AGENDA',
        label: 'Agenda'
      },
      {
        name: 'access_medical_consultation',
        value: 'ROLE_ACCESS_MEDICAL_CONSULTATION',
        label: 'Consultas'
      },
      {
        name: 'access_patient',
        value: 'ROLE_ACCESS_PATIENT',
        label: 'Pacientes'
      },
      // {
      //   name: 'access_medical_procedure',
      //   value: 'ROLE_ACCESS_MEDICAL_PROCEDURE',
      //   label: 'Procedimentos'
      // },
      {
        name: 'access_financial_statement',
        value: 'ROLE_ACCESS_FINANCIAL_STATEMENT',
        label: 'Extrato Financeiro'
      },
      {
        name: 'role_access_history',
        value: 'ROLE_ACCESS_HISTORY',
        label: 'Histórico'
      }
    ]
  },
  'doctorPassword': {
    size: 6,
    type: 'password',
    name: 'password',
    tooltip: `Essa é uma regra de segurança necessária
para validarmos ações sensíveis no sistema.
Digite sua senha para confirmar a operação.`,
    label: 'Digite sua senha',
    value: null
  }
  // 'plainPassword.second': {
  //   size: 6,
  //   type: 'password',
  //   name: 'plainPassword.second',
  //   label: 'Repita a senha',
  //   value: null,
  //   errors: {
  //     samePassword: 'Senhas não conferem'
  //   }
  // }
}

const requiredFields = [
  'secretaryUser.name', 'secretaryUser.email.first', 'secretaryUser.email.second', 'secretaryDoctorOffices', 'doctorPassword'
  // , 'plainPassword.first', 'plainPassword.second'
]
const validations = {}
for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}
validations['secretaryUser.email.second'] = {
  value: {
    required,
    sameEmail: sameAs(function () {
      return this.formData['secretaryUser.email.first'].value
    })
  }
}
validations['secretaryUser.email.first'] = {
  value: {
    required,
    email
  }
}
export {formData, validations}
